export const aboutData = {
  title: "Who I am",
  description1:
    "My name's Altaf. I'm a web designer and developer based in Bhopal, M.P.",
  description2:
    "During the day I work as a developer at a local agency and in the evening I  work on freelance projects and utilize the time to built my own products. I spent my leisure hours writing articles and poetry. Right now I'm also trying a hand at machine learning and AI. I love to learn and explore new arenas.",
  image: 2,
};
